
// import throat from 'throat';
// import to from 'await-to-js';
import {compose, defaultProps, withHandlers} from 'recompose';

import { withAxios } from 'op/components/auth';
import { withErrorHandling } from 'op/components/error';

export const withReportFailedKpi = compose(
    defaultProps({
        onChange: () => {},
    }),
    withAxios,
    withErrorHandling,
    withHandlers({
        openKpiRemarksModal : ( reportType =>  (res) => {
            if(res.kpi.failkpi && res.value < 30){
                return;
            }
        })
    }),


);

